// Modelo de datos para Rol
export class Parametros {
  constructor(data = {}) {
    console.log('🔍 Parametros constructor - data recibido:', data);
    console.log('🔍 Parametros constructor - keys disponibles:', Object.keys(data));
    
    // ✅ MAPEO CORRECTO PARA TU API (minúsculas primero)
    this.Id_parametros = data.id_parametros || data.Id_parametros || 0; 
    this.Id_sucursal = data.id_sucursal || data.Id_sucursal || 0;   
    this.Nombre = data.nombre || data.Nombre || '';    
    this.Valor = data.valor || data.Valor || '';    
    this.Valor2 = data.valor2 || data.Valor2 || '';    
    this.Tipo = data.tipo || data.Tipo || '';    
    this.Estado = data.estado || data.Estado || 'ACTIVO';
    
    
    console.log('🔍 Parametros constructor - objeto creado:', {
      Id_parametros: this.Id_parametros,
      Id_sucursal: this.Id_sucursal,
      Nombre: this.Nombre,
      Valor: this.Valor,
      Valor2: this.Valor2,
      Tipo: this.Tipo,
      Estado: this.Estado
      
      
    });
    
    if (data instanceof Parametros) {
    this.Id_parametros = data.Id_parametros;
    this.Id_sucursal = data.Id_sucursal;
    this.Nombre = data.Nombre;
    this.Valor = data.Valor;
    this.Valor2 = data.Valor2;
    this.Tipo = data.Tipo;
    this.Estado = data.Estado;
    
  } else {
    // Mapeo normal para datos de API
    this.Id_parametros = data.id_parametros ?? data.Id_parametros ?? null;
    this.Id_sucursal = data.id_sucursal ?? data.Id_sucursal ?? null;
    this.Nombre = data.nombre ?? data.Nombre ?? '';
    this.Valor = data.valor ?? data.Valor ?? '';
    this.Valor2 = data.valor2 ?? data.Valor2 ?? '';
    this.Tipo = data.tipo ?? data.Tipo ?? '';
    this.Estado = data.estado ?? data.Estado ?? 'ACTIVO';
  }
    // ✅ VALIDAR QUE SE MAPEARON CORRECTAMENTE
    if (this.Id_parametros === null) {
      console.warn('⚠️ ADVERTENCIA: Id_parametros no se pudo mapear. Data original:', data);
    }
    if (!this.Id_sucursal) {
      console.warn('⚠️ ADVERTENCIA: Id_sucursal no se pudo mapear. Data original:', data);
    }
  }

  // Validaciones
  isValid() {
    return this.Nombre.trim() !== '';
  }

  // ✅ MÉTODO PARA PUT/POST - AJÚSTALO SEGÚN EL FORMATO QUE ESPERA TU API
  toApiFormat() {
    return {
      id_parametros: this.Id_parametros,
      id_sucursal: this.Id_sucursal,
      nombre: this.Nombre,
      valor: this.Valor,
      valor2: this.Valor2,
      tipo: this.Tipo,
      estado: this.Estado
    };
  }

toCreateFormat() {
  return {
      id_sucursal: this.Id_sucursal,
      nombre: this.Nombre,
      valor: this.Valor,
      valor2: this.Valor2,
      tipo: this.Tipo,
      estado: this.Estado
  };
}

  // ✅ MÉTODO PARA DEBUG MEJORADO
  toDebug() {
    return {
      'Frontend (mayúsculas)': {
        Id_parametros: this.Id_parametros,
        Id_sucursal: this.Id_sucursal,
        Nombre: this.Nombre,
        Valor: this.Valor,
        Valor2: this.Valor2,
        Tipo: this.Tipo,
        Estado: this.Estado
      },
      'API Format (minúsculas)': this.toApiFormat(true),
      'Is Valid': this.isValid()
    };
  }
}